import Vue from 'vue'
import Vuex from 'vuex'
// import { isContext } from 'vm'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: {
      token: null
    },
    user: {
      clientId: 'BookIT',
      clientSecret: 'XnAR4KEaRB4pf2CEatP4b6Y8FQAiRUPq',
      encoded: 'Basic Qm9va0lUOlhuQVI0S0VhUkI0cGYyQ0VhdFA0YjZZOEZRQWlSVVBx',
      loggedIn: false
    },
    property: null
  },
  getters: {
    getAuthToken: state => { return state.auth.token },
    getUser: state => { return state.user },
    getProperty: state => { return state.property },
    getLoggedIn: state => { return state.user.loggedIn }
  },
  mutations: {
    setAuth (state, token) {
      console.log('setAuth Token:', token)
      state.auth.token = 'Bearer ' + token
    },
    setProperty (state, property) {
      console.log(property)
      state.property = property
    },
    setLoggedIn (state) {
      console.log('User logged in')
      state.user.loggedIn = true
    },
    setLoggedOut (state) {
      console.log('User logged out')
      state.user.loggedIn = false
    }
  },
  actions: {
    getAuthToken (context) {
      axios.get('https://us-central1-klingelplatten-360service.cloudfunctions.net/api/token/')
        .then(response => {
          context.commit('setAuth', response.data.access_token)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
})
